// apps/client/src/ui/chat/timing.ts (M0-T19) — how long a chat bubble stays above the speaker
import { tuning } from '@whiskerton/content';
export function bubbleDuration(text: string): number {
  return Math.min(tuning.chat.bubbleMaxMs, tuning.chat.bubbleBaseMs + [...text].length * tuning.chat.bubblePerCharMs);
}
